import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../components/tabs/langController";

const FaqLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            question : '',
            answer : '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => {
        return (
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>{'Pregunta'}</Label>
                        <Input
                            type="textarea"
                            rows={2}
                            name="question"
                            placeholder="Pregunta"
                            value={ child.question }
                            onChange={ e => onInputChange(e, child.lang) }
                            disabled={ disableInputs }
                        />
                    </FormGroup>
                </Col>
                <Col md="12">
                    <FormGroup>
                        <Label>{ 'Respuesta' }</Label>
                        <Input
                            type="textarea"
                            rows={10}
                            name="answer"
                            placeholder="Respuesta"
                            value={ child.answer }
                            onChange={ e => onInputChange(e, child.lang) }
                            disabled={ disableInputs }
                        />
                    </FormGroup>
                </Col>
            </Row>
        );
    }

    return(<LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />)
}

export default FaqLangs
